// MENU soundscape (owner 2026-11-02: 'add some ambiance to the menus too. Maybe a little bit of music. Nothing too
// aggressive.'). Played by the same engine as the maps (src/audio/mapAudio.ts) on the title and its sub-menus, fighter
// select, map select, run setup and the results screen; it crossfades with a map's run soundtrack.
// Ambience: a soft breeze, a faint warm air tone, the odd far bird and a sparse wind chime.
// Music: D major, 68 bpm, no drums: slow glassy pads, a soft sine bass, a sparse bell arp and a gentle flute-like motif.
import { MODES, type MapAudioDef } from './mapAudioDef';

export const MENU_AUDIO_ID = 'menu';

export const MENU_AUDIO: MapAudioDef = {
  id: MENU_AUDIO_ID,
  ambience: {
    level: 0.77,
    beds: [
      { src: 'pink', filter: 'lowpass', freq: 600, gain: 0.45, gust: { depth: 0.45, every: [3, 8], sweep: 1.5 } },
      { src: { wave: 'sine', freqs: [293.7, 440.6] }, filter: 'lowpass', freq: 900, gain: 0.008, gust: { depth: 0.9, every: [4, 9] } },
    ],
    events: [
      { kind: 'chime', every: [12, 24], gain: 0.04, pitch: 1.05, echo: 0.55 },
      { kind: 'bird', every: [14, 28], gain: 0.06, echo: 0.2 },
      { kind: 'gust', every: [10, 20], gain: 0.14 },
    ],
    echo: { l: 0.41, r: 0.62, fb: 0.45, damp: 3000, wet: 0.7 },
  },
  music: {
    mood: 'calm, warm and unhurried (D major, 68 bpm, no drums)',
    score: {
      bpm: 68, steps: 16, root: 50, mode: MODES.ionian, progression: [0, 3, 5, 4, 0, 3, 1, 4],
      pad: { wave: 'triangle', voices: 4, detune: 8, cutoff: 1500, gain: 0.08, octave: 0, send: 0.4 },
      bass: { wave: 'sine', cutoff: 400, atk: 0.08, dec: 0.8, sus: 0.6, rel: 0.6, gain: 0.3, octave: -1,
        pattern: '1-------5-------' },
      arp: { wave: 'sine', fm: { ratio: 3, index: 0.8, decay: 0.4 }, cutoff: 6000, atk: 0.003, dec: 0.9, sus: 0, rel: 0.6, gain: 0.06, octave: 1, send: 0.55, legato: 2,
        pattern: [0, -1, -1, -1, 2, -1, -1, -1, 4, -1, -1, -1, 2, -1, -1, -1] },
      lead: { wave: 'sine', cutoff: 3000, atk: 0.12, dec: 0.6, sus: 0.8, rel: 0.7, gain: 0.08, octave: 1, send: 0.55,
        vibrato: { rate: 4.5, cents: 14 }, bars: [2, 6],
        motifs: [
          { notes: [[4, 6], [2, 2], [3, 4], [2, 4], [0, 8], [null, 8]] },
          { notes: [[2, 4], [4, 4], [5, 8], [4, 4], [2, 4], [null, 8]] },
        ] },
      echo: { steps: 6, fb: 0.45, wet: 0.35, damp: 2800 },
      level: 0.59,
    },
  },
};
